export const AuthenticationOptions = {
  redirectUri: `${window.location.origin}/${import.meta.env.VITE_APP_REDIRECT_URI}`,
  clientId: import.meta.env.VITE_APP_CLIENT_ID,
};

export interface IAuthTokenRequestDTO {
  readonly grant_type: 'authorization_code';
  readonly code: string;
  readonly redirect_uri: string;
  readonly client_id: string;
}

export interface IAuthTokenResponseDTO {
  readonly access_token: string;
  readonly refresh_token: string;
}

export const defaultAuthRequestParams = {
  grant_type: 'authorization_code',
  code: '',
  redirect_uri: AuthenticationOptions.redirectUri,
  client_id: AuthenticationOptions.clientId,
};

export const refreshAccessTokenParams = {
  grant_type: 'refresh_token',
  client_id: AuthenticationOptions.clientId,
};
